export default "__VITE_ASSET__CESjEbkK__"